import { dark } from "./telia-dark";
import { light } from "./telia-light";
import type { ThemeProps } from "./theme-props";

export const teliaTheme = {
  light,
  dark,
} satisfies { light: ThemeProps; dark: ThemeProps };
